import React from 'react';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from '@material-ui/icons/Delete';
import CardContent from "@material-ui/core/CardContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BackPayItem from "./backPayItem";
import BonusMonths from "./bonusMonths";
import { earningTypes } from "../../Helpers/typeList";
import { useQueryWithStore } from 'react-admin';
import { convertCurrency } from '../../Helpers/salaryCalculator';

const BonusItem = props => {
   // console.log('ott',props)
    const [type, setType] = React.useState(props.value.type||'other');
    const [name, setName] = React.useState(props.value.name||'Other');
    const [value, setValue] = React.useState(+props.value.value||0);
    // const [leaveDays, setLeaveDays] = React.useState(+props.value.value||0);
    const [extraData, setExtraData] = React.useState(props.value.extraData||{actingDays:props.payroll.totalDaysInPayPeriod});
    const [taxOption, setTaxOption] = React.useState(props.value.taxOption || 'Taxable');
    

    const { data: positions } = useQueryWithStore({
        type: 'getList',
        resource: 'positions',
        payload: {
            pagination: { page: 1, perPage: 1000 },
            sort: { field: 'id', order: 'ASC' },
            filter: {}
        }
    });

    const { data: payScales } = useQueryWithStore({
        type: 'getList',
        resource: 'payScales',
        payload: {
            pagination: { page: 1, perPage: 1000 },
            sort: { field: 'id', order: 'ASC' },
            filter: {}
        }
    });

    const getActingAllowance = (position, actingDays, gradeValue, stepValue) => {
        // Find matching pay scale based on grade and step
        const matchingScale = payScales && payScales.find(scale => 
            scale.grade === gradeValue && 
            scale.step === stepValue
        );

        if (!matchingScale) {
            // Fallback to position's salary if no matching scale found
            const positionData = positions && positions.find(p => p.name === position)
            if (!positionData) return 0;
            return convertCurrency(positionData.basicSalary, positionData.basicCurrency || 'ETB', props.usedCurrencyRates) 
                * actingDays / props.payroll.totalDaysInPayPeriod;
        }

        // Use pay scale salary
        return convertCurrency(matchingScale.basicSalary, matchingScale.basicCurrency || 'ETB', props.usedCurrencyRates)
            * actingDays / props.payroll.totalDaysInPayPeriod;
    }

    // Get unique grades and steps from payScales
    const availableGrades = payScales ? [...new Set(payScales.map(scale => scale.grade))].sort() : [];
    const availableSteps = (grade) => {
        if (!payScales) return [];
        return [...new Set(payScales
            .filter(scale => scale.grade === grade)
            .map(scale => scale.step))]
            .sort((a, b) => a - b);
    };

    const allowanceRates = [
        {value: 0.1, name: '10%', appliesTo:['shiftAllowance','onCallAllowance']},
        {value: 0.15, name: '15%',appliesTo:['shiftAllowance','onCallAllowance']},
        {value: 0.20, name: '20%',appliesTo:['shiftAllowance']},
        {value: 0.25, name: '25%',appliesTo:['shiftAllowance']},
    ]
    return (
        <Grid container>
            <Grid item xs={3}>
                <FormControl margin='dense' fullWidth  >
                    <InputLabel>Earning Type</InputLabel>
                    <Select
                        value={type}
                        onChange={ev=> {
                            const selectedType = earningTypes.find(t=>t.id===ev.target.value)
                            setType(ev.target.value)
                            setName(selectedType.name)
                            setTaxOption(selectedType.taxOption)
                            !!selectedType.value&&setValue(selectedType.value)

                            props.onChange({type: ev.target.value, name:selectedType.name, taxOption:selectedType.taxOption,value:selectedType.value||value, extraData})                        }}
                    >
                        {earningTypes.map(to=><MenuItem key={to.id} value={to.id}>{to.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>


              <Grid item xs={3}>



                    <TextField
                        onChange={ev => {
                            setName(ev.target.value)
                            props.onChange({type, name: ev.target.value,taxOption,value, extraData})

                        }}
                        value={name}
                        margin="dense"
                        label="Title"
                        fullWidth
                    />
            </Grid>
            {type==='backPay'&&<Grid item xs={3}>
                <BackPayItem payroll={props.payroll} extraData={extraData}  onChange={d => {
                    // console.log({d})
                    setExtraData(d)
                    props.onChange({type, name, taxOption, value, extraData:d})
                }}/>
            </Grid>}
            {type==='bonus'&&<Grid item xs={3}>
                <BonusMonths payroll={props.payroll} extraData={extraData}  onChange={d => {
                    // console.log({d})
                    setExtraData(d)
                    props.onChange({type, name, taxOption, value, extraData:d})
                }}/>
            </Grid>}
            {type === 'actingAllowance' && <><Grid item xs={3}>
                <Autocomplete
                    options={positions || []}
                    getOptionLabel={(option) => `${option.name} (Grade: ${option.grade || '-'}, Step: ${option.step || 1})`}
                    value={positions ? positions.find(p => p.name === extraData.position) || null : null}
                    onChange={(event, newValue) => {
                        if (newValue) {
                            const selectedPosition = newValue;
                            const newGrade = selectedPosition.grade;
                            const newStep = selectedPosition.step || 1;
                            const currentSalaryPercentage = extraData.salaryPercentage !== undefined ? extraData.salaryPercentage : props.actingAllowancePercentage || 100;
                            const baseValue = getActingAllowance(selectedPosition.name, extraData.actingDays || props.payroll.totalDaysInPayPeriod, newGrade, newStep);
                            const newValueCalc = baseValue * (currentSalaryPercentage / 100);

                            const newExtraData = {
                                ...extraData,
                                position: selectedPosition.name,
                                grade: newGrade,
                                step: newStep
                            };
                            setExtraData(newExtraData);
                            setValue(newValueCalc);
                            props.onChange({
                                type,
                                name,
                                taxOption,
                                value: newValueCalc,
                                extraData: newExtraData
                            });
                        }
                    }}
                    renderInput={(params) => <TextField {...params} label="Acting Position" margin="dense" fullWidth />}
                />
            </Grid>
            <Grid item xs={2}>
                <Autocomplete
                    options={availableGrades}
                    getOptionLabel={(option) => option}
                    value={extraData.grade || ''}
                    onChange={(event, newValue) => {
                        // When grade changes, reset step to lowest available step for new grade
                        const newGrade = newValue;
                        const availableStepsForGrade = availableSteps(newGrade);
                        const newStep = availableStepsForGrade.length > 0 ? availableStepsForGrade[0] : 1;
                        const currentSalaryPercentage = extraData.salaryPercentage !== undefined ? extraData.salaryPercentage : props.actingAllowancePercentage || 100;
                        const baseValue = getActingAllowance(extraData.position, extraData.actingDays || props.payroll.totalDaysInPayPeriod, newGrade, newStep);
                        const newValueCalc = baseValue * (currentSalaryPercentage / 100);

                        const newExtraData = {...extraData, grade: newGrade, step: newStep};
                        setExtraData(newExtraData);
                        setValue(newValueCalc);
                        props.onChange({
                            type,
                            name,
                            taxOption,
                            value: newValueCalc,
                            extraData: newExtraData
                        });
                    }}
                    renderInput={(params) => <TextField {...params} label="Grade" margin="dense" fullWidth />}
                />
            </Grid>
            <Grid item xs={2}>
                <Autocomplete
                    options={availableSteps(extraData.grade)}
                    getOptionLabel={(option) => `Step ${option}`}
                    value={extraData.step || 1}
                    onChange={(event, newValue) => {
                        const newStep = newValue;
                        const currentSalaryPercentage = extraData.salaryPercentage !== undefined ? extraData.salaryPercentage : props.actingAllowancePercentage || 100;
                        const baseValue = getActingAllowance(extraData.position, extraData.actingDays || props.payroll.totalDaysInPayPeriod, extraData.grade, newStep);
                        const newValueCalc = baseValue * (currentSalaryPercentage / 100);

                        const newExtraData = {...extraData, step: newStep};
                        setExtraData(newExtraData);
                        setValue(newValueCalc);
                        props.onChange({
                            type,
                            name,
                            taxOption,
                            value: newValueCalc,
                            extraData: newExtraData
                        });
                    }}
                    renderInput={(params) => <TextField {...params} label="Step" margin="dense" fullWidth />}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    onChange={ev => {
                        const newDays = +ev.target.value;
                        const newPercentage = (newDays / props.payroll.totalDaysInPayPeriod * 100).toFixed(2);
                        const currentSalaryPercentage = extraData.salaryPercentage !== undefined ? extraData.salaryPercentage : props.actingAllowancePercentage || 100;
                        const baseValue = getActingAllowance(extraData.position, newDays, extraData.grade, extraData.step || 1);
                        const newValue = baseValue * (currentSalaryPercentage / 100);
                        setValue(newValue);
                        const newExtraData = {...extraData, actingDays: newDays, actingPercentage: newPercentage};
                        setExtraData(newExtraData);
                        props.onChange({
                            type, 
                            name, 
                            taxOption, 
                            value: newValue, 
                            extraData: newExtraData
                        });
                    }}
                    value={extraData.actingDays || props.payroll.totalDaysInPayPeriod}
                    type="number"
                    margin="dense"
                    label="Acting Days"
                    fullWidth
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    onChange={ev => {
                        const newPercentage = +ev.target.value;
                        const newDays = Math.round(props.payroll.totalDaysInPayPeriod * newPercentage / 100);
                        const currentSalaryPercentage = extraData.salaryPercentage !== undefined ? extraData.salaryPercentage : props.actingAllowancePercentage || 100;
                        const baseValue = getActingAllowance(extraData.position, newDays, extraData.grade, extraData.step || 1);
                        const newValue = baseValue * (currentSalaryPercentage / 100);
                        setValue(newValue);
                        const newExtraData = {...extraData, actingDays: newDays, actingPercentage: newPercentage};
                        setExtraData(newExtraData);
                        props.onChange({
                            type, 
                            name, 
                            taxOption, 
                            value: newValue, 
                            extraData: newExtraData
                        });
                    }}
                    value={extraData.actingPercentage || 100}
                    type="number"
                    margin="dense"
                    label="Acting Percentage"
                    InputProps={{
                        endAdornment: '%'
                    }}
                    
                />
            </Grid>
            <Grid item xs={1}>
                 <TextField
                    onChange={ev => {
                        const newSalaryPercentage = +ev.target.value;
                        // Recalculate value based on new salary percentage
                        const actingDays = extraData.actingDays || props.payroll.totalDaysInPayPeriod;
                        const baseValue = getActingAllowance(extraData.position, actingDays, extraData.grade, extraData.step || 1);
                        const newValue = baseValue * (newSalaryPercentage / 100);

                        setValue(newValue);
                        setExtraData({...extraData, salaryPercentage: newSalaryPercentage});
                        props.onChange({
                            type, 
                            name, 
                            taxOption, 
                            value: newValue, 
                            extraData: {...extraData, salaryPercentage: newSalaryPercentage}
                        });
                    }}
                    value={extraData.salaryPercentage !== undefined ? extraData.salaryPercentage : props.actingAllowancePercentage || 100} // Default to 100
                    type="number"
                    margin="dense"
                    label="Salary %"
                     InputProps={{
                        endAdornment: '%'
                    }}
                />
            </Grid>
            
            
            </>}
            {type==='leave'&&<Grid item xs={3}>
                <TextField
                    onChange={ev => {
                        // const v = type.toLowerCase().includes('deduction')?-Math.abs(+ev.target.value):+ev.target.value
                       const v = props.payroll.fullBasicSalary/26 * +ev.target.value

                        setValue(v)
                        setName()
                        setExtraData({...extraData,leaveDays:+ev.target.value})
                        props.onChange({type, name,taxOption,value:v,extraData:{...extraData,leaveDays:+ev.target.value}})
                    }}
                    value={extraData.leaveDays}
                    type="number"
                    autoFocus
                    margin="dense"
                    label="Leave Days"
                    fullWidth
                />
            </Grid>}
            {type!=='backPay'&&type!=='bonus'&&<Grid item xs={3}>
                <FormControl margin='dense' fullWidth>
                    <InputLabel>Tax Option</InputLabel>
                    <Select
                        value={taxOption}
                        onChange={ev => {
                            setTaxOption(ev.target.value)
                            props.onChange({type, name, taxOption: ev.target.value, value, extraData})
                        }}
                    >
                        {[
                            {id: 'NonTaxable', name: 'NonTaxable'},
                            {id: 'Taxable', name: 'Taxable'},
                            {id: 'TaxableWithLimits', name: 'TaxableWithLimits'},
                            {id: 'TaxableWithPayback', name: 'Taxable But Payback'},
                            { id: 'TaxCovered', name: 'Tax Covered By Employer (Add to Net)' },
                        ].map(to => <MenuItem key={to.id} value={to.id}>{to.name}</MenuItem>)}
                    </Select>
                </FormControl>


            </Grid>}


            {(type==='shiftAllowance'||type==='onCallAllowance')&&<Grid item xs={2}>
                <FormControl margin='dense' fullWidth>
                    <InputLabel>Allowance Rate</InputLabel>
                    <Select
                    onChange={ev => {
                        // const v = type.toLowerCase().includes('deduction')?-Math.abs(+ev.target.value):+ev.target.value
                        const v = (props.payroll.fullBasicSalary)/(props.payroll.monthlyOTHours)*ev.target.value * extraData.shiftHour
                        const selectedAllowanceRate = allowanceRates.find(s=>s.value===ev.target.value)
                        const selectedType = earningTypes.find(t=>t.id===type)||{name:'Allowance'}
                        setName(selectedAllowanceRate?selectedAllowanceRate.name+" "+selectedType.name:name);
                        setValue(v)
                        setExtraData({...extraData,shiftRate:+ev.target.value})
                        props.onChange({type, name:selectedAllowanceRate?selectedAllowanceRate.name+" "+selectedType.name:name,taxOption,value:v,extraData:{...extraData,shiftRate:+ev.target.value}})
                    }}
                    value={extraData.shiftRate}
                    autoFocus
                    margin="dense"
                    fullWidth
                >
                        {allowanceRates.filter(rate=>rate.appliesTo.includes(type)).map(rate => <MenuItem key={rate.value} value={rate.value}>{rate.name}</MenuItem>)}
                    </Select>
                </FormControl>

            </Grid>}
            {(type==='shiftAllowance'||type==='onCallAllowance')&&<Grid item xs={2}>

                <TextField
                    onChange={ev => {
                        // const v = type.toLowerCase().includes('deduction')?-Math.abs(+ev.target.value):+ev.target.value
                        const v = props.payroll.fullBasicSalary/(props.payroll.monthlyOTHours)*ev.target.value * extraData.shiftRate
                        setValue(v)
                        setExtraData({...extraData,shiftHour:+ev.target.value})
                        props.onChange({type, name,taxOption,value:v,extraData:{...extraData,shiftHour:+ev.target.value}})
                    }}
                    value={extraData.shiftHour}
                    type="number"
                    autoFocus
                    margin="dense"
                    label="Shift Hour"
                    fullWidth
                />

            </Grid>}

            <Grid item xs={2}>
                <TextField
                    onChange={ev => {
                        const v = type.toLowerCase().includes('deduction')?-Math.abs(+ev.target.value):+ev.target.value
                        setValue(v)
                        props.onChange({type, name,taxOption,value:v,extraData})
                    }}
                    value={value}
                    type="number"
                    autoFocus
                    margin="dense"
                    label="Value"
                    fullWidth
                />

            </Grid>
            <Grid item xs={1}>
                {type==='bonus'?<FormControlLabel
                    control={<Switch color='primary' checked={extraData.includeCurrentMonth !== false} onChange={ev => {
                        const newInclude = ev.target.checked
                        setExtraData({...extraData, includeCurrentMonth: newInclude})
                        props.onChange({type, name, taxOption, value, extraData:{...extraData, includeCurrentMonth: newInclude}})
                    }} />}
                    label="Include Current Month"
                />:<TextField
                onChange={ev => {

                    setExtraData({...extraData,netValue:+ev.target.value})
                    
                    props.onChange({type, name,taxOption,value,extraData:{...extraData,netValue:+ev.target.value}})
                }}
                value={extraData.netValue}
                type="number"
                margin="dense"
                label="Net Value"
                fullWidth
                />}
                </Grid>

            <Grid item xs={1}>
                <IconButton onClick={props.onRemove} aria-label="delete" >
                    <DeleteIcon fontSize="large" />
                </IconButton>



            </Grid>

        </Grid>
    );
};

export default BonusItem;
